var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "u8-rank-item" }, [
    _c("div", { staticClass: "u8-rank-item__header" }, [
      _c(
        "div",
        {
          staticClass: "u8-pb-5 u8-rank-item__header--title",
          attrs: { flex: "" },
        },
        [
          _c("div", { attrs: { "flex-box": "1" } }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _c("div", { attrs: { "flex-box": "0" } }, [
            _c("span", { staticClass: "u8-rank-item__header--value" }, [
              _vm._v(_vm._s(_vm.currVal)),
            ]),
          ]),
        ]
      ),
    ]),
    _c(
      "div",
      { staticClass: "u8-rank-item__body" },
      [
        _c(
          "el-tooltip",
          {
            staticClass: "item",
            attrs: {
              effect: "dark",
              content: _vm.desc,
              placement: "top-start",
            },
          },
          [
            _c("el-progress", {
              attrs: {
                percentage: _vm.percentage,
                "show-text": false,
                "stroke-width": 10,
                color: _vm.color,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }